import styled from "styled-components";

const List = styled.ul`
  width: 97.5%;
  margin: 1.6rem auto;
  padding: 0;
  transition: 0.2s ease;
`;

export default List;
